import getBoundingClientRect from 'bounding-client-rect';
function getOffsetHeight(elm) {
    return getBoundingClientRect(elm).height;
}
function getOffsetWidth(elm) {
    return getBoundingClientRect(elm).width;
}
function getTop(elm) {
    return getBoundingClientRect(elm).top;
}
export { getOffsetWidth };
export { getOffsetHeight };
export { getTop };
